export function hasAccess(sub_role, status, action) {
  if (!Array.isArray(sub_role)) return false;
  const found = sub_role.find(r => r.status === status);
  if (!found) return false;
  if (Array.isArray(found.action) && found.action.includes("all")) return true;
  return Array.isArray(found.action) && found.action.includes(action);
}